<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  mounted() {
  this.$nextTick(() => {
    const dropdown = this.$el.querySelector('.multiselect__content-wrapper');
    if (dropdown) {
      dropdown.style.position = 'relative';
      dropdown.style.width = `${this.$el.offsetWidth}px`;
      dropdown.style.zIndex = '99999';
    }
  });
},
  created() {
  },
}
</script>

<style lang="scss">
//@import './assets/css/animated.css';
//@import './assets/css/icons.css';
//@import './assets/css/style.css';
//@import './assets/css/plugins.css';
//@import './assets/switcher/css/switcher.css';
//@import './assets/switcher/demo.css';

</style>
